// extracted by mini-css-extract-plugin
export default {"form":"SignUpStepTwo_form__t6d85","title":"SignUpStepTwo_title__hZkAj","button":"SignUpStepTwo_button__Ngghm"};